import { useConsultation } from '@entities/consultations';
import type React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { BuyerMenu, Layout } from '@widgets/consultations';

import {
	ConnectButton,
	ConsultationAddress,
	ConsultationCost,
	ConsultationDate,
	ConsultationDuration,
	ConsultationSeller,
	ConsultationStatus,
	ConsultationTime,
	ConsultationType,
	Row,
	useBuyConsultation,
	useConsultationCost,
	useConsultationLoader,
	useConsultationMessage,
} from '@features/consultations';

import { useUser } from '@shared/hooks';
import { Card, LargeHeader } from '@shared/ui';

import { useModalCopyMessage } from '@src/features/common';

import { ModalLarge } from 'library/components/common';

import * as st from './styles.module.scss';

export const ConsultationModal: React.FC = () => {
	const { code, consultationId } = useParams<{ [x: string]: string }>();
	const navigate = useNavigate();
	const id = Number(consultationId);
	const { consultation } = useConsultation(id);
	const { costTitle } = useConsultationCost(id);

	const { user } = useUser();
	const { message } = useConsultationMessage(id);
	const { toggleCopyModal } = useModalCopyMessage();

	const { onBuy } = useBuyConsultation(id);

	const onClose = () => {
		navigate(`/consultations/${code}`);
	};

	useConsultationLoader(id, onClose);

	return (
		<ModalLarge isOpen disableHeader onRequestClose={onClose}>
			<LargeHeader title="Консультация" onClose={onClose} right={<ConnectButton id={id} />} />
			<Layout
				User={<ConsultationSeller id={id} />}
				Menu={<BuyerMenu id={id} />}
				Consultation={
					<Card className={st.consultation__card}>
						<Row title="Тип">
							<ConsultationType id={id} />
						</Row>
						<Row title="Статус" hideBackground>
							<ConsultationStatus
								id={id}
								onClick={() => (user?.is_coach ? toggleCopyModal(message) : onBuy())}
							/>
						</Row>
						<Row title="Дата">
							<ConsultationDate id={id} />
						</Row>
						<Row title="Время">
							<ConsultationTime id={id} />
						</Row>
						<Row title="Длительность">
							<ConsultationDuration id={id} />
						</Row>
						<Row title={costTitle}>
							<ConsultationCost id={id} />
						</Row>

						{consultation?.type === 'OF' && (
							<Row title="Адрес">
								<ConsultationAddress id={id} />
							</Row>
						)}
					</Card>
				}
			/>
		</ModalLarge>
	);
};
